import { lazy, Suspense } from 'react';
import './App.css';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from './pages/Home';
import HashRedirect from './components/HashRedirect';
import { Toaster } from './components/ui/toaster';

// Lazy-loaded routes: pages rarely visited stay out of the main bundle
const AdminLogin = lazy(() => import('./pages/AdminLogin'));
const AdminDashboard = lazy(() => import('./pages/AdminDashboard'));
const GuideHub = lazy(() => import('./pages/guide/GuideHub'));
const GuideArticle = lazy(() => import('./pages/guide/GuideArticle'));
const NotFound = lazy(() => import('./pages/NotFound'));

const RouteFallback = () => (
  <div className="min-h-screen flex items-center justify-center bg-white">
    <div className="w-10 h-10 border-4 border-gray-200 border-t-brand-red rounded-full animate-spin" />
  </div>
);

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Suspense fallback={<RouteFallback />}>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/admin" element={<AdminLogin />} />
            <Route path="/admin/dashboard" element={<AdminDashboard />} />
            <Route path="/guide" element={<GuideHub />} />
            <Route path="/guide/:slug" element={<GuideArticle />} />

            {/* Legacy URL redirects → homepage #servizi */}
            <Route path="/misurazioni" element={<HashRedirect to="/#servizi" />} />
            <Route path="/cantieri" element={<HashRedirect to="/#servizi" />} />
            <Route path="/muffe" element={<HashRedirect to="/#servizi" />} />
            <Route path="/riscaldamento" element={<HashRedirect to="/#servizi" />} />
            <Route path="/prosciugamento-non-invasivo" element={<HashRedirect to="/#servizi" />} />
            <Route path="/prosciugamento" element={<HashRedirect to="/#servizi" />} />

            {/* Catch-all 404 */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </Suspense>
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
